import React from 'react';
import { Breadcrumbs, Btn, H5 } from '../../../AbstractElements';
import { Card, CardBody, CardFooter, CardHeader, Col, Container, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import RoomTypesNewForm from './RoomTypesNewForm';

const RoomTypesNew = () => {
  return (
    <>
      <Breadcrumbs mainTitle="Room type" title="New room type" subParent="Room types" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <H5>New room type</H5>
                <Link to="/room-types">
                  <Btn color="primary">Back to room types</Btn>
                </Link>
              </CardHeader>
              <CardBody>
                <RoomTypesNewForm />
              </CardBody>
              <CardFooter>
                <Btn color="primary">Create</Btn>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default RoomTypesNew;
